import { render, staticRenderFns } from "./Jumpseller.vue?vue&type=template&id=2f66f120"
import script from "./Jumpseller.vue?vue&type=script&lang=ts"
export * from "./Jumpseller.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports